import {IconName} from '@wandb/weave/components/Icon';
import {TagColorName} from '@wandb/weave/components/Tag';

export const DEFAULT_LAUNCH_PROJECT_NAME = 'model-registry';

// Priority level constants are for display only.  Actual behavior is governed by the backend.
export enum PRIORITY_LEVEL {
  CRITICAL = 0,
  HIGH = 1,
  MEDIUM = 2,
  LOW = 3,
}

type PriorityLevelMetadata = {
  label: string;
  color: TagColorName;
  icon: IconName;
  adminApprovalText: string;
  placementText: string;
  preemptionText: string;
};

export const ACTIVE_STATES: readonly string[] = [
  'running',
  'stopping',
  'preempting',
  'starting',
  'idle',
  'pending',
] as const;

export const PRIORITY_LEVEL_METADATA: PriorityLevelMetadata[] = [
  {
    label: 'Critical',
    color: 'moon',
    icon: 'priority-critical',
    // TODO(np): Update this text once admin approval flow is implemented.
    adminApprovalText: 'No admin approval required.',
    placementText: 'Highest priority launches.',
    preemptionText: 'Preempts non-critical priority launches.',
  },
  {
    label: 'High',
    color: 'moon',
    icon: 'priority-high',
    adminApprovalText: 'No admin approval required.',
    placementText: 'Placed ahead of medium priority launches.',
    preemptionText: 'Preemptible by critical priority launches.',
  },
  {
    label: 'Medium',
    color: 'moon',
    icon: 'priority-none',
    adminApprovalText: 'No admin approval required.',
    placementText: 'Placed ahead of low priority launches.',
    preemptionText: 'Preemptible by critical priority launches.',
  },
  {
    label: 'Low',
    color: 'moon',
    icon: 'priority-low',
    adminApprovalText: 'No admin approval required.',
    placementText: 'Lowest priority launches.',
    preemptionText: 'Preemptible by critical priority launches.',
  },
];
